import Big from 'big.js'
import Badge from 'src/common/ui-kit/Badge'
import clsx from 'clsx'
import { ZERO } from 'src/common/utils/big-utils'
import TokenBalance from 'src/common/components/TokenBalance/TokenBalance'
import { AnyToken } from 'src/common/types/models/Tokens'
import Icon from 'src/common/ui-kit/Icon/Icon'
import useBalance from 'src/common/contracts/hooks/token/useBalance'
import { useTranslation } from 'react-i18next'
import useBreakpoint from 'src/common/hooks/ui/useBreakpoint'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'

export interface TokenAmountController {
  token?: AnyToken
  balance?: Big | null
  max?: Big | null
  value?: Big
  onChange: (value: Big) => void
  disabled?: boolean
  className?: string
}

const TokenAmountController = ({
  token,
  value = ZERO,
  max,
  onChange,
  disabled = false,
  className,
}: TokenAmountController) => {
  const isSm = useBreakpoint('sm')
  const { smartAccountInfo } = useSmartAccount()
  const { balance } = useBalance({
    token,
    owner: smartAccountInfo?.address,
  })

  const { t } = useTranslation('trade')

  const canBeActive = Boolean(balance && !disabled && !balance.eq(Big(0)))
  let maxToSelect = max || balance
  const halfBalance = maxToSelect
    ? token?.type === 'ERC20'
      ? maxToSelect.div(2)
      : maxToSelect.div(2).round(0)
    : ZERO

  const handleMaxAmount = () => {
    onChange(maxToSelect || ZERO)
  }
  const handleHalfMaxAmount = () => {
    onChange(halfBalance)
  }

  const classes = clsx(
    'flex items-center gap-2',
    disabled && 'opacity-80',
    className
  )

  const isHalfActive = canBeActive && value.eq(halfBalance)
  const isMaxActive = canBeActive && value.eq(balance || ZERO)

  return (
    <div className={classes}>
      <TokenBalance
        token={token}
        StartAdornment={<Icon width={14} name='wallet' />}
        ownerAddress={smartAccountInfo?.address}
      />
      {!isSm && (
        <Badge
          active={isHalfActive}
          color='secondary'
          onClick={handleHalfMaxAmount}
        >
          {t('tokenAmountController.half')}
        </Badge>
      )}
      <Badge active={isMaxActive} color='secondary' onClick={handleMaxAmount}>
        {t('tokenAmountController.max')}
      </Badge>
    </div>
  )
}

export default TokenAmountController
